
<div style="display: flex;justify-content: center;margin-top: 0.5%">
  <div class="container1" style="width: 60%">
    <h2 >Stock de Menajería</h2>
    <div>
      <mat-form-field appearance="outline" style="width: 100%;height: 50%;font-size: 14px">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field>
    </div>

    <!--    <div *ngIf="loadingService.isLoading | async" class="spinner"  >-->
    <!--      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>-->
    <!--    </div>-->


    <!--    <div *ngIf="(loadingService.isLoading | async) === false" >-->
    <div  >
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="margin-top: 0.4%">
        <ng-container matColumnDef="id" >
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="nombre" >
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
        </ng-container>

        <ng-container matColumnDef="marca" >
          <th mat-header-cell *matHeaderCellDef>Marca</th>
          <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
        </ng-container>

        <ng-container matColumnDef="modelo" >
          <th mat-header-cell *matHeaderCellDef>Modelo</th>
          <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
        </ng-container>

        <ng-container matColumnDef="cantidad" >
          <th mat-header-cell *matHeaderCellDef>Cantidad</th>
          <td mat-cell *matCellDef="let element">{{ element.cantidad }}</td>
        </ng-container>

        <ng-container matColumnDef="modificar">
          <th mat-header-cell *matHeaderCellDef> Editar </th>
          <td mat-cell *matCellDef="let element;let i=index">
            <button mat-icon-button color="primary" (click)="openDialogModify(i)">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <th mat-header-cell *matHeaderCellDef> Eliminar </th>
          <td mat-cell *matCellDef="let element;let i=index">
            <button mat-icon-button color="primary" (click)="deleteArticulo(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                     showFirstLastButtons>
      </mat-paginator>
    </div>

    <div class="row" style="margin-top: 2%" >
      <button mat-raised-button color="primary" (click)="openDialogAdd()">Agregar Artículo</button>
    </div>
  </div>

</div>




